import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getNotifications, markNotificationsDeleted, markNotificationsRead } from '@/redux/modules/notification';
import noop from '@/utils/noop';

export const useNotificationDataProps = () => {
    const dispatch = useAppDispatch();
    const notifications = useAppSelector(getNotifications);

    const markRead = useCallback((ids: number[]) => dispatch(markNotificationsRead(ids)), [dispatch]);
    const markDeleted = useCallback((ids: number[]) => dispatch(markNotificationsDeleted(ids)), [dispatch]);

    return {
        count: notifications.length,
        markDeleted,
        markRead,
        notifications,
        trackView: noop,
    };
};
